import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import { LeadsView } from '../../../modules/leads/leads-view'

const leadsSearchSchema = z.object({
  q: z.string().optional(),
  stage: z.enum(['lead', 'prospect']).optional(),
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.string().optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
})

/** `/leads` - the hosting prospect workspace. */
export const Route = createFileRoute('/_authed/leads/')({
  validateSearch: leadsSearchSchema,
  component: LeadsRoute,
})

function LeadsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <LeadsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
